module.exports = __webpack_public_path__ + "static/img/logo1.cb41dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo1.png
// module id = LJ2z
// module chunks = 1